/* eslint-disable comma-dangle */
/* eslint-disable semi */
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { API_URL } from "../configs/apiConfig";
import axios from "axios";
export const fetchWinners_participants = createAsyncThunk(
  "fetchWinners_participants/fetchAll",
  async (_, rejectWithValue) => {
    try {
      const adminToken = localStorage.getItem("adminToken");
      if (!adminToken) {
        return rejectWithValue("Authentication token not found.");
      }
      const response = await axios.get(`${API_URL}/admin/competitions/counts`, {
        headers: {
          Authorization: `Bearer ${adminToken}`,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
const fetchWinners_participantsSlice = createSlice({
  name: "fetchWinners_participants",
  initialState: {
    data: {},
    pending: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchWinners_participants.pending, (state) => {
        state.pending = true;
        state.error = null;
      })
      .addCase(fetchWinners_participants.fulfilled, (state, action) => {
        state.pending = false;
        state.data = action.payload;
      })
      .addCase(fetchWinners_participants.rejected, (state, action) => {
        state.pending = false;
        state.error = action.payload;
      });
  },
});
export default fetchWinners_participantsSlice.reducer;
